import React, { useState, useContext } from 'react'
import { Box, Button, LinearProgress, CircularProgress } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { GlobalStateContext } from '../context/globalStateProvider';
import AvartarImg from '../assets/avatar_img.svg'
import config from "../config.json";
import { CAR_HANDOVER, getActivityConfig } from '../utils/shareData';
import { formatTimestamp } from '../utils/dateTime';
import { toast } from 'react-toastify';

const Feedback = ({ currentActivity, activitiesPercentage, alreadyRated, rating, setRating}) => {
    const { setViewAllActivities } = useContext(GlobalStateContext)
    const theme = useTheme();
    const activityUI = getActivityConfig(currentActivity.event);

    const handleStarClick = (selectedRating) => {
        setRating(selectedRating)
    }

    if (currentActivity.event !== 'Handed Over') return null
    return (
        <Box>
            <Box sx={{ padding:"0px 40px", textAlign: "center", color: theme.palette.darkBlue.main, fontSize: "20px", fontWeight: theme.typography.fontWeightSemibold }}>
                Thank You for choosing ParkSmart Valet
            </Box>

            {/* <Box sx={{padding:"0px 26px", textAlign: "center", color: theme.palette.darkBlue.main, fontSize: "14px", fontWeight: theme.typography.fontWeightMedium, marginTop:"8px" }}>
                Your feedback is valuable to us. Please take a moment to rate your experience.
            </Box> */}

            {/* <Box sx={{marginTop:"0px"}}>
                <Box sx={{...theme.customStyles.ratingContent}}>
                    {[1, 2, 3, 4, 5].map((star) => (
                        <span key={star} onClick={() => { if (!alreadyRated) handleStarClick(star) }} style={{ cursor: "pointer", color: star <= rating ? "gold" : "#DCDCDC", padding: "12px",}}>
                            &#9733;
                        </span>
                    ))}
                </Box>
            </Box> */}

            <Box sx={{ width: "100%", height: "1.5px",  background: 'repeating-linear-gradient(to right, #DCDCDC 0, #DCDCDC 6px, transparent 6px, transparent 12px)', marginTop: "5px" }} />
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "18px" }}>
                <Box sx={{ color: theme.palette.darkBlue.main, fontSize: "14px", fontWeight: theme.typography.fontWeightMedium }}>{activityUI.label}</Box>
                <Button onClick={() => setViewAllActivities(prev => !prev)} variant='text' sx={{ color: "#279AEB", fontSize: "14px", fontWeight: theme.typography.fontWeightMedium, fontFamily: theme.typography.fontFamily, textTransform: "none" }}>View Valet Journey</Button>
            </Box>

            <Box sx={{ marginTop: "8px" }}>
                <LinearProgress variant="determinate" value={activitiesPercentage} />
            </Box>


            <Box sx={{ display: "flex", justifyContent: "flex-start", alignItems: "center", borderRadius: "8px", border: "1px solid #EFEFEF", padding: "16px", marginTop: "24px" }}>
                <img src={AvartarImg} alt='Avatar' width={32} height={32} />
                <Box sx={{marginLeft: "8px"}}>
                    <Box sx={{ color: theme.palette.darkBlue.main, fontSize: "14px", fontWeight: theme.typography.fontWeightMedium }}>{activityUI.label}</Box>
                    <Box sx={{ color: theme.palette.lightGray.main, fontSize: "11px", fontWeight: theme.typography.fontWeightMedium }}>{formatTimestamp(currentActivity.timestamp, 'MMM D, YYYY • h:mm A')}</Box>
                </Box>
            </Box>
        </Box>
    )
}

const FeedbackHandler = ({bookingId, currentActivity, alreadyRated, refresh, rating}) => {
    const theme = useTheme();
    const [loading, setLoading] = useState(false)
    const save = () => {
        setLoading(true)
        const data = { rating};
        fetch(`${config.HOST_NAME}/website/bookingParkings/${bookingId}/ratings`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            body: JSON.stringify(data)
        })
            .then(response => response.json())
            .then(json => {
                if (json.success) refresh()
                else toast.info(json.message)
            })
            .catch((error) => {
                console.log(error)
                toast.error('Something went wrong');
            })
            .finally(() =>{
                setLoading(false)
            })
    };

    if (currentActivity.event !== "Handed Over" || alreadyRated) return null

    return (
            <Box sx={theme.customStyles.valetRecallContainer}>
                <Button onClick={() => save()} disabled={!rating} sx={{ ...theme.customStyles.gradientButton, height: "40px", borderRadius: "4px", padding: "0", marginTop: "8px", color: "#FFFFFF" }}>
                    <Box sx={{ fontSize: "14px", fontWeight: theme.typography.fontWeightSemibold }}>Rate Your Experience</Box>
                    {loading && <CircularProgress color="inherit" size={14} style={{ marginLeft: 15 }} />}
                </Button>
            </Box> 
    )
}

export {Feedback, FeedbackHandler}
